import { format, isValid, parseISO } from 'date-fns'

import { ColourId } from '@acre/design-system'
import ledgerTypeValues from '@acre/graphql/client-helpers/union-values/ledgerTypeValues'
import { pascalCase } from '@acre/utils'

export const formatDate = (date: string | null | undefined) => {
  return date && isValid(parseISO(date)) ? format(parseISO(date), 'dd/MM/yyyy') : ''
}

export const getTagColor = (status: LedgerStatus | LedgerRecurringPaymentsStatus | null | undefined) => {
  switch (status) {
    case 'SETTLED':
    case 'IN_FORCE':
    case 'LIVE':
      return ColourId.Green
    case 'DUE':
    case 'PARTIALLY_PAID':
    case 'OVERDUE':
      return ColourId.Yellow
    case 'PARTIALLY_WRITTEN_OFF':
    case 'WRITTEN_OFF':
    case 'CLOSE':
    case 'CANCELLED':
      return ColourId.Grey
    default:
      return ColourId.Grey
  }
}

const ledgerPaymentTypesPrefix = 'accounting.ledgerPaymentTypes'

export const LEDGER_PAYMENT_TYPE_MAP: { [key in LedgerType]: string } = ledgerTypeValues.reduce(
  (acc, value) => {
    acc[value as LedgerType] = `${ledgerPaymentTypesPrefix}.${pascalCase(value)}`
    return acc
  },
  {} as { [key in LedgerType]: string },
)
